import $ from "jquery";

$(document).ready(function () {
    // Get the pathname to check for products page
    const urlParams = new URLSearchParams(window.location.search);
    let searchPage = false;
    // Loop through the search parameters and store them in the object
    urlParams.forEach(function(value, key) {
        if(key == 's') {
            searchPage = true;
        }
    });

    if(searchPage) {
        // Define the minimum number of search results
        let posts_per_page = 5;
        const increment = 5;
        const page_results = $('.search-item');

        // Hide the load more and display no results section when no results are available
        if(!page_results.length > 0) {
            $('.no-result').show();
            $('.load-more-wrapper').hide();
        }

        if(Math.ceil(page_results.length / posts_per_page) > 1) {
            $('.load-more-wrapper').show();
        }

        // Load initial posts
        for(let i = 0; i< posts_per_page; i++) {
            $(page_results[i]).show();
        }

        $('.load-more-wrapper').on('click', function() {
            for(let i = posts_per_page; i< posts_per_page + increment; i++) {
                $(page_results[i]).show();
            }
            posts_per_page = posts_per_page + increment;
            if(page_results.length == posts_per_page) {
                $(this).hide();
            }
        })
    }
});
